import en from './translations/en.json'
import he from './translations/he.json'

export default {
    en, he
}